import React, { useEffect, useState } from "react";
import { Box, Button, Chip, Paper, Stack, TextField, Typography } from "@mui/material";
import { asArray, readValue } from "../utils/storefrontApi";

const RangeFilter = ({ name, facet, onApply, disabled }) => {
  const selectedMinimum = readValue(facet, "selectedMinimum", "SelectedMinimum") ?? "";
  const selectedMaximum = readValue(facet, "selectedMaximum", "SelectedMaximum") ?? "";
  const [minimum, setMinimum] = useState(selectedMinimum);
  const [maximum, setMaximum] = useState(selectedMaximum);
  useEffect(() => { setMinimum(selectedMinimum); setMaximum(selectedMaximum); }, [selectedMinimum, selectedMaximum]);
  const invalid = (minimum !== "" && !Number.isFinite(Number(minimum))) || (maximum !== "" && !Number.isFinite(Number(maximum)))
    || (minimum !== "" && maximum !== "" && Number(minimum) > Number(maximum));
  return <Stack spacing={1}>
    <Typography variant="caption" color="text.secondary">{readValue(facet, "minimum", "Minimum")} – {readValue(facet, "maximum", "Maximum")}</Typography>
    <Stack direction="row" spacing={1}>
      <TextField size="small" type="number" label={`${name} minimum`} value={minimum} onChange={(event) => setMinimum(event.target.value)} error={invalid} />
      <TextField size="small" type="number" label={`${name} maximum`} value={maximum} onChange={(event) => setMaximum(event.target.value)} error={invalid} />
      <Button disabled={disabled || invalid} onClick={() => onApply(minimum, maximum)}>Apply</Button>
      <Button disabled={disabled} onClick={() => { setMinimum(""); setMaximum(""); onApply("", ""); }}>Clear</Button>
    </Stack>
  </Stack>;
};

export default function StorefrontFacets({ facets, onToggle, onRange, disabled }) {
  if (facets == null) return null;
  return <Paper elevation={0} sx={{ p: 2, border: "1px solid rgba(15,23,42,.08)", borderRadius: "18px" }}>
    <Typography sx={{ fontWeight: 850 }}>Filters</Typography>
    {!Object.keys(facets).length && <Typography variant="body2" color="text.secondary">No filters available for this search.</Typography>}
    <Stack spacing={1.5} sx={{ mt: 1 }}>
      {Object.entries(facets).map(([key, facet]) => {
        const configured = Boolean(readValue(facet, "configured", "Configured"));
        const range = readValue(facet, "isRange", "IsRange") || readValue(facet, "minimum", "Minimum") != null || readValue(facet, "maximum", "Maximum") != null;
        return <Box key={key}>
          <Typography variant="subtitle2">{key}</Typography>
          {range ? <RangeFilter name={key} facet={facet} disabled={disabled} onApply={(min, max) => onRange(key, min, max, configured)} />
            : <Stack direction="row" spacing={.5} flexWrap="wrap" useFlexGap>
              {asArray(readValue(facet, "buckets", "Buckets")).map(bucket => {
                const value = readValue(bucket, "value", "Value");
                const selected = Boolean(readValue(bucket, "selected", "Selected"));
                const clickable = configured || key !== "availability" || value === "in-stock";
                return <Chip key={value} clickable={clickable} disabled={disabled} size="small"
                  onClick={clickable ? () => onToggle(key, value, selected, configured) : undefined}
                  color={selected ? "warning" : "default"} variant={selected ? "filled" : "outlined"}
                  label={`${readValue(bucket, "label", "Label") || value} · ${readValue(bucket, "count", "Count") ?? 0}`} />;
              })}
            </Stack>}
        </Box>;
      })}
    </Stack>
  </Paper>;
}
